const adminProjectsRoutes = [
    {
        name: 'projects-portfolios',
        path: 'education/projects',
        component: () => import('pages/sot.bot.admin/projects/ProjectsPage.vue'),
        children: [
            {
                name: 'projects-portfolio',
                path: ':portfolioId',
                component: () => import('pages/sot.bot.admin/projects/portfolios/ProjectPortfolio.vue'),
                props: true,
                children: [
                    {
                        name: 'project-admin',
                        path: ':projectId',
                        component: () => import('pages/sot.bot.admin/projects/portfolios/projects/Project.vue'),
                        props: true,
                    },
                ],
            },
        ],
    },
];

export default adminProjectsRoutes;
